import { useTranslation } from 'react-i18next';
import type { Infer } from 'superstruct';
import { enums } from 'superstruct';

import { su, theme, typography } from '@adflow/frontend/ui-theme';

import { Menu, MenuButton, MenuItem, MenuList } from './MenuButton';

export const ExportTypeDto = enums(['xlsx', 'csv'] as const);

export type ExportTypeDto = Infer<typeof ExportTypeDto>;

export interface ExportButtonProps {
	onClick: (type: ExportTypeDto) => void;

	disabled?: boolean;
	tooltip?: string;
}

/**
 * Export button for grid pages.
 */
// TODO Make a components library for the grid pages because they have so much in common. Move this component to that library.
export function ExportButton({
	onClick,
	disabled,
	tooltip,
}: ExportButtonProps) {
	const { t } = useTranslation('common');

	return (
		<Menu
			trigger={
				<MenuButton
					disabled={disabled}
					css={[
						typography.clickableLink,
						su.textXs,
						disabled && {
							color: theme.colors.text.hint,
							cursor: 'not-allowed',
						},
					]}
					title={tooltip}
					data-testid="export-button"
				>
					{t('Export')}
				</MenuButton>
			}
		>
			<MenuList>
				<MenuItem onSelect={() => onClick('xlsx')}>Excel</MenuItem>
				<MenuItem onSelect={() => onClick('csv')}>CSV</MenuItem>
			</MenuList>
		</Menu>
	);
}
